import Screen from "../lib/Screen";

import * as PIXI from "pixi.js";
import gsap from "gsap";

import ServiceLocator from "../ServiceLocator";
import Button from "../lib/Button";
import Utils from "../Utils";
import Session, { game_type } from "../Session";
import CreateProfilePopup from "./popup/CreateProfilePopup";
import MathcMakingPopup from "./popup/MatchMakingPopup";
import { screen_type } from "../state/GameState";
import HostPrivateRoomPopup from "./popup/HostPrivateRoomPopup";
import { LiveEventData, LiveEventDataType, LivePlayerDataEvent, LivePresenceAction } from "../lib/game_snacks/ILiveMultiplayer";
import Settings from "./Settings";
import TutorialPopup from "./popup/TutorialPopup";
import GuestPrivateRoomPopup from "./popup/GuestPrivateRoomPopup";
import { game_event_type } from "../service/MultiplayerEventManager";
import RoundOverPopup from "./popup/RoundOverPopup";
import { Profile } from "../lib/game_snacks/IUser";
import PRNG from "../lib/PRNG";
import Spinner from "./game/Spinner";
import RadialSpinner from "./game/RadialSpinner";
import LobbyBigButton, { lobby_big_button_type } from "./LobbyBigButton";
import ProfileRequiredPopup from "./popup/ProfileRequiredPopup";
import GSAvatarLoader from "../lib/GSAvatarLoader";


export default class LobbyScreen extends Screen
{
    // #region Attributes //

    // private:

    private _bg: PIXI.Sprite = null;
    private _title: PIXI.Text = null;
    private _profileAvatar: PIXI.Sprite = null;
    private _profileTitle: PIXI.Text = null;
    private _classicModeBtn: LobbyBigButton = null;
    private _friendsModeBtn: LobbyBigButton = null;
    private _matchMakingPopup: MathcMakingPopup = null;
    private _settings: Settings = null;

    private _spinner: RadialSpinner = null; // TEST:
    private _roundOverPopup: RoundOverPopup = null;

    private _gameLogoWrapper: PIXI.Container = null;

    // #endregion //


    // #region Methods //

    // public:

    public constructor()
    {
        super();
    }

    public onEnter( params: any = null ): void
    {
        super.onEnter();

        if ( params && params.gameLogoWrapper )
        {
            this._gameLogoWrapper = params.gameLogoWrapper;
        }

        if ( params && params.isFadeIn )
        {
            this._root.interactiveChildren  = false;

            let g: PIXI.Graphics = ServiceLocator.app.root.children[ 0 ] as PIXI.Graphics;
            ServiceLocator.app.root.addChild( g );
            gsap.to( g, { alpha: 0, duration: 0.4, ease: "sine.in", onComplete: () => {
                this._root.interactiveChildren = true;
            } } );
        }

        this._bg = new PIXI.Sprite( ServiceLocator.resources.bg.texture );
        this._bg.anchor.set( 0.5 );
        this._bg.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( this._bg );

        if ( this._gameLogoWrapper )
        {
            this._root.addChild( this._gameLogoWrapper );
        }
        else
        {
            this._gameLogoWrapper = new PIXI.Container();
            this._root.addChild( this._gameLogoWrapper );
            //
            let gameLogo: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.game_logo.texture );
            gameLogo.position.set( ServiceLocator.app.width * 0.5, 140 );
            gameLogo.anchor.set( 0.5, 0 );
            this._gameLogoWrapper.addChild( gameLogo );
            //
            /*const kArrSparkPos: Array<number> = [ 
                80, 226,
                48, 216,
                406, 231,
                265, 14,
                436, 212 ];
            const kArrSparkSize: Array<number> = [ 38, 18, 38, 28, 18 ];
            const kArrSparkId: Array<string> = [
                "spark_04",
                "spark_05",
                "spark_05",
                "spark_02",
                "spark_03" ];
            for ( let i: number = 0; i < 5; ++i )
            {
                let spark: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources[ kArrSparkId[ i ] ].texture );
                spark.anchor.set( 0.5 );
                spark.scale.set( kArrSparkSize[ i ] / spark.texture.width );
                spark.position.set( kArrSparkPos[ i * 2 ] + 90, kArrSparkPos[ i * 2 + 1 ] + 150 );
                this._gameLogoWrapper.addChild( spark );

                let sparkTween: gsap.core.Tween = gsap.from( spark.scale, { x: spark.scale.x * 0.8, y: spark.scale.y * 0.8, duration: 0.4 + Math.random() * 0.4, repeat: -1, yoyo: true, ease: "sine.inOut" } );
                sparkTween.progress( Math.random() );
            }*/
        }

        this._profileAvatar = new PIXI.Sprite( ServiceLocator.resources.avatar_you.texture );
        this._profileAvatar.scale.set( 100/this._profileAvatar.texture.width );
        this._profileAvatar.anchor.set( 0, 0.5 );
        GSAvatarLoader.i.load( 
            Session.i.profile ? Session.i.profile.avatar.src : "avatar_you", 
            ( texture: PIXI.Texture ) => {
                try 
                {
                    this._profileAvatar.texture = texture;
                    this._profileAvatar.scale.set( 100/this._profileAvatar.texture.width );
                }
                catch( ex ) {}
            } );
        this._profileAvatar.position.set( 16, 58 + 7.5 );
        this._root.addChild( this._profileAvatar );

        this._profileTitle = new PIXI.Text( Session.i.profile ? Session.i.profile.username.prefix : "", { fontFamily: "asap_bold", fontSize: 40, fill: 0x474747, stroke: 0xffffff, strokeThickness: 6, lineJoin: "round" } );
        this._profileTitle.anchor.set( 0, 0.5 );
        this._profileTitle.position.set( this._profileAvatar.x + 120, 58 + 2 );
        this._root.addChild( this._profileTitle );
        //
        Utils.fitTextToWidth( this._profileTitle, 300 );

        this._classicModeBtn = new LobbyBigButton();
        this._classicModeBtn.type = lobby_big_button_type.CLASSIC;
        this._classicModeBtn.init();
        this._classicModeBtn.scale.set( 0.97 );
        this._classicModeBtn.position.set( 305 * 0.5 + 4, 790 );
        this._root.addChild( this._classicModeBtn );
        this._classicModeBtn.onTap.add( () => { this._root.interactiveChildren = false; } );
        this._classicModeBtn.onSelectionAnimCompleted.add( () => { 
            this._root.interactiveChildren = true;

            this._onPlayBtn_Click(); 
        } );

        this._friendsModeBtn = new LobbyBigButton();
        this._friendsModeBtn.type = lobby_big_button_type.PLAY_WITH_FRIENDS;
        this._friendsModeBtn.init();
        this._friendsModeBtn.scale.set( 0.97 );
        this._friendsModeBtn.position.set( ServiceLocator.app.width - 305 * 0.5 - 8, this._classicModeBtn.y );
        this._root.addChild( this._friendsModeBtn );
        this._friendsModeBtn.onTap.add( () => { this._root.interactiveChildren = false; } );
        this._friendsModeBtn.onSelectionAnimCompleted.add( () => { 
            this._root.interactiveChildren = true;

            this._onPrivateGameBtn_Click(); 
        } );

        this._settings = new Settings();
        this._settings.init( false );
        this._settings.position.set( ServiceLocator.app.width - 58, 58 );
        this._root.addChild( this._settings );
        this._settings.onTutorial.add( () => { 
            let tutorialPopup: TutorialPopup = new TutorialPopup();
            tutorialPopup.init();
            this._root.addChild( tutorialPopup );
            tutorialPopup.onClosed.add( ( popup: TutorialPopup ) => {
                popup.end();
            } );
        } );
        //
        const kSettingsScale: number = 100 / this._settings.width;
        this._settings.position.x -= 58 * ( kSettingsScale - 1 ); 
        this._settings.position.y += 58 * ( kSettingsScale - 1 ) - 4; 
        this._settings.scale.set( kSettingsScale );

        // TODO: This situation should not happen. 
        /*if ( Session.i.isInvite && !Session.i.profile )
        {
            Session.i.isInvite = false;

            let createProfilePopup: CreateProfilePopup = new CreateProfilePopup();
            createProfilePopup.onEnter();
            createProfilePopup.onClosed.add( this._onCreateProfilePopup_Closed, this );
        }*/

        ServiceLocator.multiplayerEventManager.onProfileChange.add( this._onProfile_Changed, this );

        if ( params )
        {
            if ( params.isPlay )
            {
                this._matchMakingPopup = new MathcMakingPopup();
                this._matchMakingPopup.onEnter();
                this._matchMakingPopup.onClosed.add( this._onMatchMakingPopup_Closed, this );
                this._matchMakingPopup.onGameStarted.add( this._onMatchMaking_GameStarted, this );
            }
            else if ( params.isPlayPrivate )
            {
                if ( !params.isPrivateHost )
                {
                    Utils.showMessagePopup( "The host left the room." );
                }
                else
                {
                    for ( let i: number = Session.i.room.length - 1; i >= 0; --i )
                    {
                        Session.i.room[ i ].isReady = false;
                    }
                    if ( Session.i.profile.uid == Session.i.room[ 0 ].uid )
                    {
                        Session.i.room[ 0 ].isReady = true;
                        while ( Session.i.roomEvents.length > 0 )
                        {
                            const kRoomEvent: LiveEventData = Session.i.roomEvents.shift();
                            if ( !kRoomEvent.type )
                            {
                                const kPayload: any = JSON.parse( kRoomEvent.payload );
                                if ( kPayload.type == game_event_type.JOINED_PRIVATE_ROOM )
                                {
                                    const kProfileUid: string = JSON.parse( kRoomEvent.payload ).uid;
                                    for ( let profile of Session.i.room )
                                    {
                                        if ( profile.uid == kProfileUid )
                                        {
                                            profile.isReady = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        let privateRoomPopup: HostPrivateRoomPopup = new HostPrivateRoomPopup();
                        privateRoomPopup.url = Session.i.privateRoomUrl;
                        privateRoomPopup.onEnter();
                        privateRoomPopup.onClosed.add( this._onHostPrivateRoomPopup_Closed, this );
                        privateRoomPopup.onGameStarted.add( this._onHostPrivateRoomPopup_GameStarted, this );
                        //
                        privateRoomPopup.checkPrivateRoomReady();
                    }
                    else
                    {
                        let privateRoomPopup: GuestPrivateRoomPopup = new GuestPrivateRoomPopup();
                        privateRoomPopup.onEnter();
                        privateRoomPopup.onClosed.add( this._onGuestPrivateRoomPopup_Closed, this );
                        privateRoomPopup.onGameStarted.add( this._onGuestPrivateRoomPopup_GameStarted, this );
                    }
                }
            }
            else if ( params.isKicked )
            {
                Utils.showMessagePopup( "Oops! You have been kicked from the game due to inactivity." );
            }
        }

        // TEST:
        /*Session.i.room = [];
        let botCount: number = 0;
        while ( Session.i.room.length < Session.i.kGameRoomSize )
        {
            let profile: Profile = { 
                username: { prefix: [ "YOU", "Lizs", "Marcos", "Henryyyyyyyy" ][ botCount ], suffix: botCount.toString() },
                avatar: { src: "avatar_" + botCount.toString(), alt: null },
                uid: Session.i.room.length.toString() };
            profile.isBot = botCount > 0;
            Session.i.room.push( profile );

            botCount += 1;
        }  
        Session.i.profile = Session.i.room[ 0 ];
        Session.i.prng = new PRNG( 1 );
        window.setTimeout( () => { this._onCompleted.dispatch( screen_type.GAMEPLAY ); }, null );

        let matchMakingData: any = { arrRoundScore: [ 400, 30, 20, 300 ], arrTotalScore: [ 1200, 121, 122, 1230 ], round: 1 };
        this._roundOverPopup = new RoundOverPopup();
        this._roundOverPopup.playerIndex = 0;
        this._roundOverPopup.isGameOver = true;
        this._roundOverPopup.round = matchMakingData.round;
        this._roundOverPopup.roundScores = matchMakingData.arrRoundScore;
        this._roundOverPopup.lastScores = matchMakingData.arrTotalScore;
        this._roundOverPopup.onEnter();
        //
        /*let wrapper: PIXI.Container = new PIXI.Container();
        wrapper.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        this._root.addChild( wrapper );
        //
        let characterSprite: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.avatar_0.texture );
        characterSprite.scale.set( 116/characterSprite.texture.width );
        characterSprite.y = characterSprite.height * 0.5;
        characterSprite.anchor.set( 0.5, 1 );
        wrapper.addChild( characterSprite );
        //
        this._spinner = new RadialSpinner();
        this._spinner.innerRadius = 116 * 0.5;
        this._spinner.outerRadius = 116 * 0.5 + 10;
        this._spinner.color = 0xffd21f;
        this._spinner.init();
        wrapper.addChild( this._spinner );
        //
         this._spinner.setProgress( 0.75 );*/

        /*let test2: PIXI.Sprite = new PIXI.Sprite( ServiceLocator.resources.avatar_you.texture );
        test2.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        test2.anchor.set( 0.5 );
        this._root.addChild( test2 );

        let test: PIXI.Sprite = new PIXI.Sprite();
        test.position.set( ServiceLocator.app.width * 0.5, ServiceLocator.app.height * 0.5 );
        test.anchor.set( 0.5 );
        this._root.addChild( test );

        new GSAvatarLoader( "resources/img/common/avatar/9.svg", ( texture: PIXI.Texture ) => {
            test.texture = texture;

            test.scale.set( 100/test.texture.width ); 
        } );*/
    }

        private _onPlayBtn_Click(): void
        {
            this._root.interactiveChildren = false;
            window.setTimeout( () => {
                this._root.interactiveChildren = true;

                if ( Session.i.profile )
                {
                    this._matchMakingPopup = new MathcMakingPopup();
                    this._matchMakingPopup.onEnter();
                    this._matchMakingPopup.onClosed.add( this._onMatchMakingPopup_Closed, this );
                    this._matchMakingPopup.onGameStarted.add( this._onMatchMaking_GameStarted, this );
                }
                else
                {
                    window.GameSnacks.user.requestProfile()
                        .then( 
                            ( profile: Profile ) => { 
                                this._root.interactiveChildren = true;
                                                    
                                if ( profile )
                                {
                                    ServiceLocator.saved.data.userId = profile.username.suffix;
                                    ServiceLocator.saved.save();

                                    Session.i.profile = profile;

                                    this._onProfileCreated( game_type.MATCHMAKING );
                                }
                                else
                                {
                                    let createProfilePopup: ProfileRequiredPopup = new ProfileRequiredPopup();
                                    createProfilePopup.selGameType = game_type.MATCHMAKING;
                                    createProfilePopup.onEnter();
                                    createProfilePopup.onClosed.add( this._onCreateProfilePopup_Closed, this );
                                }
                            }
                        );
                }
            }, 100 );
        }

            private _onMatchMakingPopup_Closed( popup: MathcMakingPopup ): void
            {
                popup.onLeave();
                this._matchMakingPopup = null;
            }

            private _onMatchMaking_GameStarted( popup: MathcMakingPopup ): void
            {
                popup.onLeave();
                this._matchMakingPopup = null;

                Session.i.gameType = game_type.MATCHMAKING;

                this._onCompleted.dispatch( screen_type.GAMEPLAY );
            }

            private _onProfileCreated( selGameType: game_type ): void
            {
                GSAvatarLoader.i.load( 
                    Session.i.profile.avatar.src, 
                    ( texture: PIXI.Texture ) => {
                        try
                        {
                            this._profileAvatar.texture = texture;
                            this._profileAvatar.scale.set( 100/this._profileAvatar.texture.width );
                        }
                        catch( ex ) {}
                    } );
                this._profileTitle.text = Session.i.profile.username.prefix;

                if ( selGameType == game_type.MATCHMAKING )
                {
                    this._onPlayBtn_Click();
                }
                else if ( selGameType == game_type.PRIVATE_1_VS_4 )
                {
                    this._onPrivateGameBtn_Click();
                }
            }

            private _onCreateProfilePopup_Closed( popup: ProfileRequiredPopup, selGameType: game_type ): void
            {
                popup.onLeave();

                if ( selGameType !== null )
                {
                    this._onProfileCreated( selGameType );
                }
            }

        private _onPrivateGameBtn_Click(): void
        {
            this._root.interactiveChildren = false;
            window.setTimeout( () => {
                if ( Session.i.profile )
                {
                    this._root.interactiveChildren = false;

                    ServiceLocator.multiplayerEventManager.onPlayerPresenceUpdated.addOnce( ( presenceEventPromise: Promise<LivePlayerDataEvent> ) => {
                        presenceEventPromise
                            .then( ( livePlayerDataEvent: LivePlayerDataEvent ) => {
                                if ( livePlayerDataEvent.action == LivePresenceAction.JOIN )
                                {
                                    if ( livePlayerDataEvent.isHost )
                                    {
                                        Session.i.profile.uid = livePlayerDataEvent.uid;
                                    }
                                }
                            } );
                    } );
                    window.GameSnacks.liveMultiplayer.createRoom()
                        .then( 
                            ( privateRoomUrl: string ) => { 
                                this._root.interactiveChildren = true;

                                Session.i.room = [ Session.i.profile ];

                                let privateRoomPopup: HostPrivateRoomPopup = new HostPrivateRoomPopup();
                                privateRoomPopup.url = privateRoomUrl;
                                privateRoomPopup.onEnter();
                                privateRoomPopup.onClosed.add( this._onHostPrivateRoomPopup_Closed, this );
                                privateRoomPopup.onGameStarted.add( this._onHostPrivateRoomPopup_GameStarted, this );
                            },
                            () => { this._root.interactiveChildren = true; }
                        );
                }
                else
                {
                    window.GameSnacks.user.requestProfile()
                        .then( 
                            ( profile: Profile ) => { 
                                this._root.interactiveChildren = true;
                                                    
                                if ( profile )
                                {
                                    ServiceLocator.saved.data.userId = profile.username.suffix;
                                    ServiceLocator.saved.save();

                                    Session.i.profile = profile;

                                    this._onProfileCreated( game_type.PRIVATE_1_VS_4 );
                                }
                                else
                                {
                                    let createProfilePopup: ProfileRequiredPopup = new ProfileRequiredPopup();
                                    createProfilePopup.selGameType = game_type.PRIVATE_1_VS_4;
                                    createProfilePopup.onEnter();
                                    createProfilePopup.onClosed.add( this._onCreateProfilePopup_Closed, this );
                                }
                            }
                        );
                }
            }, 100 );
        }

            private _onHostPrivateRoomPopup_Closed( popup: HostPrivateRoomPopup ): void
            {
                popup.onLeave();
            }

            private _onHostPrivateRoomPopup_GameStarted( popup: HostPrivateRoomPopup ): void
            {
                popup.onLeave();

                Session.i.gameType = game_type.PRIVATE_1_VS_4;

                this._onCompleted.dispatch( screen_type.GAMEPLAY );
            }

        private _onGuestPrivateRoomPopup_Closed( popup: GuestPrivateRoomPopup ): void
        {
            popup.onLeave();

            Session.i.room = [];
        }

        private _onGuestPrivateRoomPopup_GameStarted( popup: GuestPrivateRoomPopup ): void
        {
            popup.onLeave();

            Session.i.gameType = game_type.PRIVATE_1_VS_4;

            this._onCompleted.dispatch( screen_type.GAMEPLAY );
        }
        
        private _onProfile_Changed( profile: Profile ): void
        {
            if ( !Session.i.profile )
            {
                Session.i.profile = profile;
            }
            else
            {
                ( Session.i.profile.username as any ) = profile.username;
                ( Session.i.profile.avatar as any ) = profile.avatar;
            }

            GSAvatarLoader.i.load( 
                Session.i.profile.avatar.src, 
                ( texture: PIXI.Texture ) => {
                    try
                    {
                        this._profileAvatar.texture = texture;
                        this._profileAvatar.scale.set( 100/this._profileAvatar.texture.width );
                    }
                    catch( ex ) {}
                } );

            this._profileTitle.text = Session.i.profile.username.prefix;
            this._profileTitle.scale.set( 1 );
            //
            Utils.fitTextToWidth( this._profileTitle, 300 );
        }

    public onUpdate( dt: number ): void 
    {
        if ( this._matchMakingPopup )
        {
            this._matchMakingPopup.onUpdate( dt );
        }
        
        if ( this._roundOverPopup )
        {
            this._roundOverPopup.onUpdate( dt );
        }

        this._classicModeBtn.update( dt );
        this._friendsModeBtn.update( dt );
    }

    public onLeave(): void
    {
        ServiceLocator.multiplayerEventManager.onProfileChange.remove( this._onProfile_Changed, this );

        this._settings.end();
        this._settings = null;

        this._classicModeBtn.end();
        this._classicModeBtn = null;

        this._friendsModeBtn.end();
        this._friendsModeBtn = null;

        if ( this._gameLogoWrapper )
        {
            for ( let i: number = 1; i < this._gameLogoWrapper.children.length; ++i )
            {
                gsap.killTweensOf( this._gameLogoWrapper.children[ i ].scale );
            }
            this._gameLogoWrapper = null;
        }

        super.onLeave();
    }

    // #endregion //
}
